import { render } from "./SqueezeBreadcrumb.vue?vue&type=template&id=5e09227c&scoped=true&ts=true"
import script from "./SqueezeBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./SqueezeBreadcrumb.vue?vue&type=script&lang=ts"

import "./SqueezeBreadcrumb.vue?vue&type=style&index=0&id=5e09227c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e09227c"]])

export default __exports__